import { createAction, props } from '@ngrx/store';
import { TextTemplateLanguageEntity } from '../../entities/text-template-language.entity';


export const TextTemplateLanguageActionTypes = {
    Load: createAction('data/TextTemplateLanguage/get', props<any>()),
    UpdateAll: createAction('data/TextTemplateLanguage/updateAll', props<{ Payload: Array<TextTemplateLanguageEntity>, updateLatestUpdatedAt?: boolean }>()),
};

